import { render, staticRenderFns } from "./JoinUs.vue?vue&type=template&id=7fc580ba&scoped=true"
import script from "./JoinUs.vue?vue&type=script&lang=js"
export * from "./JoinUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc580ba",
  null
  
)

export default component.exports